<template>
	<div data-name="老师列表">
		<div class="filter-inline-panel cle">
			<el-form :inline="true" :model="pages" class="filter-panel" size="mini">
				<!-- <el-form-item :label="$t('teacher_index.type')">
					<el-select v-model="pages.type" clearable class="w100" :placeholder="$t('index.pleaseInput')">
						<el-option v-for="(item,index) in TEACHER_TYPE" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="parseFloat(item.code)"></el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item>
					<el-button type="primary" size="mini" @click="search()">{{$t('index.search')}}</el-button>
					<el-button type="primary" size="mini" @click="reset()">{{$t('index.reset')}}</el-button>
				</el-form-item>
			</el-form>
			<div class="list-opinion fr">
				<el-button type="primary" size="mini" @click="add('')" v-if="hasBtn('add')">{{$t('index.add')}}</el-button>
			</div>
		</div>
		<el-table :data="list" size="mini" border>
			<el-table-column :prop="lang=='cn'?'name_cn':'name'" align="center" width="100" :label="$t('teacher_index.name')"></el-table-column>
			<el-table-column prop="thumb" align="center" width="140" :label="$t('teacher_index.thumb')">
				<template slot-scope="scope">
					<el-image style="width: 100px; height: 100px" v-if="scope.row.thumb" :src="scope.row.thumb" fit="contain"></el-image>
					<span v-if="!scope.row.thumb">{{$t('index.image_wu')}}</span>
				</template>
			</el-table-column>
			<el-table-column :prop="lang=='cn'?'course_cn':'course'" align="center" :label="$t('teacher_index.course')"></el-table-column>
			<el-table-column :prop="lang=='cn'?'description_cn':'description'" align="center" :label="$t('teacher_index.description')"></el-table-column>
			<el-table-column :prop="lang=='cn'?'class_description_cn':'class_description'" align="center" :label="$t('teacher_index.class_description')" :formatter="content_f"></el-table-column>
			<el-table-column :label="$t('index.operation')" align="center" width="280">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" v-if="hasBtn('edit')" @click="add(scope.row)">{{$t('index.edit')}}</el-button>
					<el-button size="mini" type="info" v-if="hasBtn('del')" @click="del(scope.row)">{{$t('index.del')}}</el-button>
					<el-button size="mini" type="danger" v-if="hasBtn('status')&&scope.row.is_up==1" @click="up(scope.row,0)">{{$t('course_index.up_0')}}</el-button>
					<el-button size="mini" type="success" v-if="hasBtn('status')&&scope.row.is_up==0" @click="up(scope.row,1)">{{$t('course_index.up_1')}}</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="page-pagination">
			<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pagerCount="5"></el-pagination>
		</div>
		<el-dialog :title="$t('index.dialog_title')" :close-on-click-modal="false" :visible.sync="editFormVisible" width="1200px">
			<el-form ref="editForm" size="mini" label-position="top" :rules="editFormRules" :model="editForm">
				<el-row :gutter="10">
					<el-col :span="6">
						<el-form-item :label="$t('teacher_index.user_name')" prop="user_name">
							<el-input v-model="editForm.user_name" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<span v-if="editForm.id">
						<el-col :span="6">
							<el-form-item :label="$t('teacher_index.password')" prop="password_">
								<el-input v-model="editForm.password" show-password :placeholder="$t('index.pleaseInput')"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item :label="$t('teacher_index.re_password')" prop="re_password_password">
								<el-input v-model="editForm.re_password" show-password :placeholder="$t('index.pleaseInput')"></el-input>
							</el-form-item>
						</el-col>
					</span>
					<span v-if="!editForm.id">
						<el-col :span="6">
							<el-form-item :label="$t('teacher_index.password')" prop="password">
								<el-input v-model="editForm.password" show-password :placeholder="$t('index.pleaseInput')"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item :label="$t('teacher_index.re_password')" prop="re_password">
								<el-input v-model="editForm.re_password" show-password :placeholder="$t('index.pleaseInput')"></el-input>
							</el-form-item>
						</el-col>
					</span>
					<el-col :span="6">
						<el-form-item :label="$t('teacher_index.email')" prop="email">
							<el-input v-model="editForm.email" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="6">
						<el-form-item :label="$t('index.cn')+$t('teacher_index.name')"  prop="name_cn">
							<el-input v-model="editForm.name_cn" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('index.en')+$t('teacher_index.name')" prop="name">
							<el-input v-model="editForm.name" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('index.cn')+$t('teacher_index.description')" prop="description_cn">
							<el-input v-model="editForm.description_cn" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('index.en')+$t('teacher_index.description')" prop="description">
							<el-input v-model="editForm.description" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="3">
						<el-form-item :label="$t('teacher_index.thumb')" prop="thumb">
							<upload :value="editForm.thumb" name="company" @callback="function(res, file){imageSuccess(res, file,'thumb')}"></upload>
						</el-form-item>
					</el-col>
					<el-col :span="9">
						<el-form-item :label="$t('course_index.zoom')" prop="zoom" data-name="zoom链接">
							<el-input v-model="editForm.zoom" :placeholder="$t('index.pleaseInput')" type="textarea" :autosize="{ minRows: 5, maxRows: 5}"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="9">
						<el-form-item :label="$t('teacher_index.type')" prop="type" data-name="类型">
							<el-select v-model="editForm.type" placeholder="请选择">
								<el-option v-for="(item,index) in TEACHER_TYPE" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="parseFloat(item.code)"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item :label="$t('index.cn')+$t('teacher_index.course')" prop="course_cn">
							<el-input v-model="editForm.course_cn" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('index.en')+$t('teacher_index.course')" prop="course">
							<el-input v-model="editForm.course" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('index.cn')+$t('teacher_index.class_description')" prop="class_description_cn" label-width="136px">
							<el-input v-model="editForm.class_description_cn" :autosize="{ minRows: 5, maxRows: 5}" type="textarea" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('index.en')+$t('teacher_index.class_description')" prop="class_description" label-width="136px">
							<el-input v-model="editForm.class_description" :autosize="{ minRows: 5, maxRows: 5}" type="textarea" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="8">
						<el-form-item :label="$t('teacher_index.video')" prop="url1" label-width="136px">
							<el-input v-model="editForm.url1" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="$t('teacher_index.facebook')" prop="url2" label-width="136px">
							<el-input v-model="editForm.url2" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="$t('teacher_index.youku')" prop="url3" label-width="136px">
							<el-input v-model="editForm.url3" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col> -->
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item :label="$t('index.cn')+$t('teacher_index.content')" prop="content_cn">
							<editor-bar v-model="editForm.content_cn" :isClear="false"></editor-bar>

							<!-- <el-input v-model="editForm.content_cn" :autosize="{ minRows: 5, maxRows: 5}" type="textarea" :placeholder="$t('index.pleaseInput')"></el-input> -->
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('index.en')+$t('teacher_index.content')" prop="content">
							<editor-bar v-model="editForm.content" :isClear="false"></editor-bar>
							<!-- <el-input v-model="editForm.content" :autosize="{ minRows: 5, maxRows: 5}" type="textarea" :placeholder="$t('index.pleaseInput')"></el-input> -->
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	computed:{
		editFormRules_(){
			return {
				user_name: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('teacher_index.user_name'),
					trigger: 'blur'
				}, ],
				// country: [{
				// 	required: true,
				// 	message: this.$t('index.select')+this.$t('teacher_index.country'),
				// 	trigger: 'change'
				// }, ],
				password: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('teacher_index.password'),
					trigger: 'blur'
				}, ],
				thumb: [{
					required: true,
					message: this.$t('index.upload')+this.$t('teacher_index.thumb'),
					trigger: 'blur'
				}, ],
				name: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.en')+this.$t('teacher_index.name'),
					trigger: 'blur'
				}, ],
				name_cn: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.cn')+this.$t('teacher_index.name'),
					trigger: 'blur'
				}, ],
				course: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.en')+this.$t('teacher_index.course'),
					trigger: 'blur'
				}, ],
				course_cn: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.cn')+this.$t('teacher_index.course'),
					trigger: 'blur'
				}, ],
				description: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.en')+this.$t('teacher_index.description'),
					trigger: 'blur'
				}, ],
				description_cn: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.cn')+this.$t('teacher_index.description'),
					trigger: 'blur'
				}, ],
				content: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.en')+this.$t('teacher_index.content'),
					trigger: 'blur'
				}, ],
				content_cn: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.cn')+this.$t('teacher_index.content'),
					trigger: 'blur'
				}, ],
				class_description: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.en')+this.$t('teacher_index.class_description'),
					trigger: 'blur'
				}, ],
				class_description_cn: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.cn')+this.$t('teacher_index.class_description'),
					trigger: 'blur'
				}, ],
			}
		}
	},
	data() {
		const validatorEmail = (rule, value, callback) => {
			if (!value) {
				return callback(new Error(this.$t('home.confirm_password')));
			} else {
				if (value == this.editForm.password) {
					callback();
				} else {
					return callback(new Error(this.$t('home.two_passwords')))
				}
			}
		};
		const validator = (rule, value, callback) => {
			if (this.editForm.password != '' && this.editForm.re_password != this.editForm.password) {
				return callback(new Error(this.$t('home.two_passwords')))
			} else {
				callback();
			}
		};
		return {
			is_co:sessionStorage.getItem('is_co'),
			editFormRules:{
				re_password: [{
					required: true,
					validator:validatorEmail,
					trigger: 'blur'
				}, ],
				re_password_password: [{
					validator: validator,
					trigger: 'blur'
				}, ],
			},
			http:process.env.API_UP,
			filterForm: {},
			list: [],
			editForm: {},
			editFormVisible: false,
			image: '',
			password: '',
			re_password: '',
			pages: {
				page: 1,
				count: 100,
				perpage: 20,
				type:'',
			},
			DATA_RIGHTS:[],
			TEACHER_TYPE:[],
		}
	},
	// 初始事件
	mounted: function () {
		this.editFormRules=Object.assign(this.editFormRules,this.editFormRules_);
		this.config();
		this.init();
	},
	// 事件
	methods: {
		config(){
			var this_ = this;
			var url = "getDictionaryValue";
			var datas = {
				code:"DATA_RIGHTS,TEACHER_TYPE"
			};
			this_.$post(url, datas).then((res) => {
				this_.DATA_RIGHTS = res.DATA_RIGHTS;
				this_.TEACHER_TYPE = res.TEACHER_TYPE;
			})
		},
		// 初始化
		init: function () {
			var this_ = this;
			var url = "teacherList"
			var datas = {
				page: this_.pages.page,
				num: this_.pages.perpage,
				type: this_.pages.type,
			}
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.num;
			})
		},
		// 搜索
		search() {
			this.pages.page = 1;
			this.init();
		},
		// 重置
		reset() {
			this.pages = this.$options.data().pages;
			this.init();
		},
		add(data) {
			if (data) {
				this.editForm = JSON.parse(JSON.stringify(data));
			} else {
				this.editForm = {
					user_name: '',
					password: '',
					re_password: '',
					email: '',
					name: '',
					name_cn: '',
					thumb: '',
					course: '',
					course_cn: '',
					description: '',
					description_cn: '',
					content: '',
					content_cn: '',
					class_description: '',
					class_description_cn: '',
					type: 1,
					// country: '',
					url1: '',
					url2: '',
					url3: '',
					zoom: '',
				}
			}
			if (this.$refs.editForm) {
				this.$refs.editForm.resetFields();
			}
			this.editFormVisible = true;
		},
		editSubmit() {
			var this_ = this;
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					var url = "addTeacher";
					var datas = {
						user_name: this_.editForm.user_name,
						password: this_.editForm.password||'',
						re_password: this_.editForm.re_password||'',
						name: this_.editForm.name,
						email: this_.editForm.email,
						name_cn: this_.editForm.name_cn,
						course: this_.editForm.course,
						course_cn: this_.editForm.course_cn,
						description: this_.editForm.description,
						description_cn: this_.editForm.description_cn,
						content: this_.editForm.content,
						content_cn: this_.editForm.content_cn,
						class_description: this_.editForm.class_description,
						class_description_cn: this_.editForm.class_description_cn,
						type: this_.editForm.type,
						country:'us',
						url1: this_.editForm.url1,
						url2: this_.editForm.url2,
						url3: this_.editForm.url3,
						zoom: this_.editForm.zoom,
					}
					if (this_.image) {
						datas['thumb'] = this_.image;
					}
					var tishi = this_.$t('index.add_success');
					if (this_.editForm.id) {
						datas['teacher_id'] = this_.editForm.id;
						tishi = this_.$t('index.modify_success');
						url = 'editTeacher';
					}
					this_.$post(url, datas).then((res) => {
						this_.$message.success(tishi);
						this_.editFormVisible = false;
						this_.init();
					});
				}
			})
		},
		del(data) {
			var this_ = this;
			var url = "deleteTeacher";
			var datas = {
				teacher_id: data.id
			};
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},
		// 头像上传
		imageSuccess(res, file) {
			var this_ = this;
			if (res.status == 200) {
				this_.image = res.data.savename;
				this_.editForm.thumb = res.data.showname;
				this_.$refs.editForm.clearValidate('thumb');
			} else {
				this_.$message.success(res.message);
			}
		},
		// 头像上传
		imageSuccess_(res, file) {
			var this_ = this;
			if (res.status == 200) {
				this_.editForm.timetable_url = res.data.savename;
				this_.editForm.timetable = res.data.showname;
			} else {
				this_.$message.success(res.message);
			}
		},
		content_f(w,s,d){
			return d.substring(0,50)+'...';
		},
		up(data,value){
			var this_ = this;
			var url = "changeField";
			var datas = {
				pk_id: data.info_id,
				table:'teacher_info',
				field:'is_up',
				value:value,
			};
			this_.$post(url, datas).then((res) => {
				this_.$message.success(this_.$t('index.operation_success'));
				this_.init();
			})
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		}

	},
	// 过滤器
	filters: {

	}
}
</script>
<style>
.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.avatar-uploader .el-upload:hover {
	border-color: #409EFF;
}
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 100px;
	height: 100px;
	line-height: 100px;
	text-align: center;
}
.avatar {
	width: 100px;
	height: 100px;
	display: block;
}
</style>
<style scoped>
.dib{
	display: inline-block;
}
.filter-inline-panel {
	margin-bottom: 18px;
}
.pingweibuyao {
	position: absolute;
	left: -142px;
	top: 0;
	width: 1px;
	opacity: 0;
}
.content-panel {
	min-height: calc(100vh - 252px);
	background: #ffffff;
	padding: 25px 30px;
}
.content-panel .page-pagination {
	padding: 25px 10px;
	text-align: right;
}
.content-panel .page-pagination .filter-inline-panel {
	margin-bottom: 25px;
}
.content-panel .page-pagination .filter-inline-panel .add-data-base .el-select {
	width: 100%;
}
.filter-panel {
	display: inline-block;
	width: 80%;
	vertical-align: top;
}
.list-opinion {
	display: inline-block;
	width: 18%;
	text-align: right;
	vertical-align: top;
}
.dialog-bottom-btn {
	text-align: center;
}
.list-btn-group {
	margin: 0;
}
.list-btn-group a {
	color: #1890FF;
	cursor: pointer;
	margin: 0 5px;
}
.col_bai:hover,
.col_bai {
	color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/teacher/index.vue